import Language from '../language';

export class Audience_Translation {
  audienceId: number;

  languageId: number;

  name: string;

  description?: string;

  lang?: Language;

  constructor() {
    this.audienceId = 0;
    this.languageId = 0;
    this.name = '';
  }
}
